var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"connectionFee"},[_c('v-row',[_c('v-col',[_c('breadcrumb',{attrs:{"items":_vm.breadcrumbs}})],1)],1),_c('connection-fee-table',{attrs:{"connection-fee-url":_vm.connectionFeeUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }